export const blogs = [
  {
    title: 'The Goldilocks Zone',
    description: 'My thoughts on building imperfectly usable software.',
    publishedAt: '2025-07-18',
    slug: 'the-goldilocks-zone',
  },
  {
    title: 'Creating Sentro',
    description: 'Creating a low-level tool to build and manage design systems at scale.',
    publishedAt: '2025-05-31',
    slug: 'creating-sentro',
  },
];